import { Checkbox, TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';

import { AI_AGREEMENT_URL } from '@/features/ai_agents_setting/components/AiAgentServicesSetting/constants';
import { useTranslation } from '@/i18n';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type ContentsProps = {
  agreedToTerms: boolean;
  onAgreedToTermsChange: (checked: boolean) => void;
};

export const Contents: FC<ContentsProps> = ({
  agreedToTerms,
  onAgreedToTermsChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cx('container')}>
      <div className={cx('paragraph')}>
        <span className={cx('text')}>
          {t('ai_agents_setting_main_setting_confirm_enable_start_body')}
        </span>
        <div className={cx('link-container')}>
          <TextLink
            href={AI_AGREEMENT_URL}
            target='_blank'
            className={cx('link')}
          >
            {t(
              'ai_agents_setting_main_setting_confirm_enable_start_service_terms_link'
            )}
          </TextLink>
        </div>
      </div>
      <div className={cx('checkbox-container')}>
        <Checkbox
          checked={agreedToTerms}
          onChange={(e) => onAgreedToTermsChange(e.target.checked)}
          label={t(
            'ai_agents_setting_main_setting_confirm_enable_start_agree_to_terms_label'
          )}
        />
      </div>
    </div>
  );
};
